const converterTime = ( time ) => {
    
    time = time.replace(/\D/g, " ");
    let elements = time.split(" ");
    let date = new Date(Date.UTC.apply(null, elements));
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let timing = hours >= 12 ? "PM" : "AM";

    let finalTime = (`${hours%12}:${minutes} ${timing}`);
    
   return finalTime;
}

export default converterTime;